import { ServerException } from '../../../Booking/actions/constants';
import { HttpStatusCodes } from '../../../Booking/constants';
import { stringifyIdsFromBody } from '../../../Booking/utils/bodyIdTransform';
import getMonolithHost from '../../../utils/getMonolithHost';

export function requiresRedirect(status) {
    return (
        status === HttpStatusCodes.Unauthorized ||
        status === HttpStatusCodes.Forbidden ||
        status === HttpStatusCodes.NotFound ||
        status === HttpStatusCodes.UnprocessableEntity
    );
}

const apiHost = getMonolithHost();
export default function fetchBookingState({ fetchFunc, bookingId }) {
    return fetchFunc(
        `${apiHost}/api/rest/scheduling/v1/requests/${bookingId}`
    ).then((response) => {
        if (response.status !== HttpStatusCodes.OK) {
            throw new ServerException({
                message:
                    response.message ||
                    `Received ${response.status} in GET booking state.`,
                errorCode: response.status,
                response,
                bookingState: { bookingId },
            });
        }
        return response
            .json()
            .then(stringifyIdsFromBody)
            .then((body) => ({
                status: response.status,
                body,
            }));
    });
}
